import { useState } from "react";
import { api } from "@/api";
import { toast } from "sonner";
import { LogOut, Images, Inbox, Brush, Settings2 } from "lucide-react";
import AdminChantiers from "@/components/admin/AdminChantiers";
import AdminDevis from "@/components/admin/AdminDevis";
import AdminServices from "@/components/admin/AdminServices";
import AdminSettings from "@/components/admin/AdminSettings";

const tabs = [
  { id: "chantiers", label: "Réalisations", icon: Images },
  { id: "devis", label: "Demandes de devis", icon: Inbox },
  { id: "services", label: "Services", icon: Brush },
  { id: "reglages", label: "Infos & réglages", icon: Settings2 },
];

const AdminDashboard = ({ user, onLogout }) => {
  const [tab, setTab] = useState("chantiers");

  const logout = async () => {
    await api.post("/auth/logout").catch(() => {});
    toast.success("Déconnecté");
    onLogout();
  };

  return (
    <div data-testid="admin-dashboard">
      <div className="flex flex-wrap items-center justify-between gap-4">
        <div>
          <p className="text-xs uppercase tracking-[0.3em] text-clay">Administration</p>
          <h1 className="mt-2 font-serif text-3xl tracking-tight">
            Bonjour <em className="italic text-clay">{user.name || "Alexis"}</em>
          </h1>
        </div>
        <button
          onClick={logout}
          data-testid="admin-logout"
          className="flex items-center gap-2 rounded-full border border-ink/20 px-5 py-2.5 text-sm text-bark transition-colors duration-300 hover:border-clay hover:text-clay"
        >
          <LogOut size={15} /> Se déconnecter
        </button>
      </div>

      <nav className="mt-10 flex flex-wrap gap-2 border-b border-ink/10 pb-4" data-testid="admin-tabs">
        {tabs.map((t) => (
          <button
            key={t.id}
            onClick={() => setTab(t.id)}
            data-testid={`admin-tab-${t.id}`}
            className={`flex items-center gap-2 rounded-full px-5 py-2.5 text-sm transition-colors duration-300 ${
              tab === t.id ? "bg-ink text-cream" : "bg-plaster text-bark hover:bg-sand/40"
            }`}
          >
            <t.icon size={15} /> {t.label}
          </button>
        ))}
      </nav>

      <div className="mt-10">
        {tab === "chantiers" && <AdminChantiers />}
        {tab === "devis" && <AdminDevis />}
        {tab === "services" && <AdminServices />}
        {tab === "reglages" && <AdminSettings />}
      </div>
    </div>
  );
};

export default AdminDashboard;
